<template lang="pug">
  .component-client-action-buttons
    ModalReveal
      button.button.warning(slot="trigger", type="button") Edit
      .row
        .columns
          label Name
            input(type="text", v-model="item.name")
          label Priority
            input(type="text", v-model="item.priority")
        .columns
          label Group
            select(v-model="item.group")
              option ALL
              option GENERAL
              option PLAN
      .row.columns.text-center
        button.button(@click="edit") Save Toc Type

    button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'
  import ModalReveal from '../../foundation/ModalReveal'

  export default {
    name: 'TocTypeButtons',
    components: {ModalReveal},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>TT${this.item.id} toc type?</strong>`, () => {
          KeplerBackofficeSdk.tocTypes.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', 'Toc removed')
            window.location.reload()
          })
        })
      },
      edit() {
        KeplerBackofficeSdk.tocTypes.select(this.item).edit(this.item, () => {
          window.location.reload()
        })
      }
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TocTypeButtons.vue?66220156